const districtAdmin2 = {
  id: '60943fd0-a0c5-11e8-9b9e-1747b90086c6',
  email: 'masteryprepdistrictadmin@example.com',
  username: 'masteryprepdistrictadmin@example.com',
  firstName: 'MasteryPrep District',
  lastName: 'Admin',
  fullName: 'MasteryPrep District Admin',
  lastModified: 1521738144176,
  created: 1521738144176,
  role: 'District Admin',
  isTeacher: false,
  schoolDistrict: '072c10d0-a0c5-11e8-9b9e-1747b90086c6',
  state: 'LA',
  validated: true,
}

export default districtAdmin2


// WEBPACK FOOTER //
// ./src/helpers/users/testing/districtAdmin2.js